import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {ReplaySubject} from "rxjs";
import {FormRow} from "../../../shared/interface/form-row";
import {FormAddService} from "../../../shared/services/form-add.service";
import {delay, distinctUntilChanged, first, takeUntil, tap} from "rxjs/operators";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {Form} from "../../../shared/interface/form";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {AddPartnerToFormDialogComponent} from "../add-partner-to-form-dialog/add-partner-to-form-dialog.component";
import {ActivatedRoute, Router} from "@angular/router";
import {FilterService} from "../../../shared/services/filter.service";
import {NgForm} from "@angular/forms";
import {MatSnackBar} from "@angular/material/snack-bar";
import {select, Store} from "@ngrx/store";
import {getCurrentRouteState} from "../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../shared/ngrx/route-serializer";
import {StoreRootState} from "../../../shared/ngrx/reducers";
import {JobResultDialogComponent} from "../../../shared/components/job-result-dialog/job-result-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {Uuid} from "../../../shared/interface/response/uuid";
import {ChangeFormRowStatusDialogComponent} from "../change-form-row-status-dialog/change-form-row-status-dialog.component";
import {
  DICT_TYPE_FORM_ROW_STATUS,
  DictService, FORM_ROW_STATUS_LOSS,
  FORM_ROW_STATUS_NEW, FORM_ROW_STATUS_SUCCESS, FORM_ROW_STATUS_TO_BE_SERVED, REGISTRATION_STATUS_TO_DEREGISTER,
} from "../../../shared/services/dict.service";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {AuthService} from "../../../shared/services/auth.service";
import {Registration} from "../../../shared/interface/registration";
import {ConfirmDialogComponent} from "../../../shared/components/confirm-dialog/confirm-dialog.component";
import {co} from "@fullcalendar/core/internal-common";
@Component({
  selector: 'app-dynamic-form-apply-list',
  templateUrl: './dynamic-form-apply-list.component.html',
  styleUrls: ['./dynamic-form-apply-list.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class DynamicFormApplyListComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('filtersForm') filtersForm: NgForm;
  @Output() closeModification = new EventEmitter<any>();
  @Input() dynamicFormId?: string;
  @Input() embeddedView = false;
  readonly  FORM_ROW_STATUS_NEW = FORM_ROW_STATUS_NEW;
  readonly  FORM_ROW_STATUS_TO_BE_SERVED = FORM_ROW_STATUS_TO_BE_SERVED;
  readonly REGISTRATION_STATUS_TO_DEREGISTER = REGISTRATION_STATUS_TO_DEREGISTER;
  readonly FORM_ROW_STATUS_LOSS = FORM_ROW_STATUS_LOSS;
  readonly FORM_ROW_STATUS_SUCCESS = FORM_ROW_STATUS_SUCCESS;
  items: FormRow[] = [];
  displayedColumns: string[] = ['createdAt', 'email', 'partner', 'serviceTime' ,  'status', 'actions'];
  modify = false;
  totalData = 0;
  expandedElement: FormRow = null;
  saveExpandedElement: FormRow = null;
  initialFilters: any;
  userPermissions: ReplaySubject<UserPermissions>;


  sortBy = 'createdAt';
  sortOrder = 'asc';

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(
    private store: Store<StoreRootState>,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private formService: FormAddService,
    private filterService: FilterService,
    private snack: MatSnackBar,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.formService.formRowListSubject
      .pipe
      (takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<FormRow>) => {
          this.items = e.items;
          this.totalData = e.pagination.total;
          if (this.saveExpandedElement) {
            this.items.forEach((formRow: FormRow) => {
              if (formRow.uuid === this.saveExpandedElement.uuid) {
                this.expandedElement = formRow;
              }
            });
            this.saveExpandedElement = null;
          }
        }))
      .subscribe();
    this.parseFilters();
  }
  ngAfterViewInit(): void {
    this.activatedRoute.data
      .pipe(
        delay(0),
        first()
      )
      .subscribe((data: any) => {
        this.displayedColumns = data.displayedColumns ?? this.displayedColumns;

        if (!this.embeddedView) {
          this.store
            .pipe(
              select(getCurrentRouteState),
              delay(0),
              distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
              takeUntil(this.destroyed$),
            )
            .subscribe((state2: RouterStateUrl) => {
              this.parseFilters(state2.params);
              this.paginator.pageIndex = state2.params.page;
              this.paginator.pageSize = state2.params.pageSize;
              this.sortBy = state2.params?.sortBy ? state2.params.sortBy : 'createdAt';
              this.sortOrder = state2.params?.sortOrder ? state2.params.sortOrder : 'asc';
            });
        } else {
          this.loadListData();
        }
      });
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
        if (this.embeddedView){
          this.loadListData();
        } else {
          this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
            sortBy: this.sortBy,
            sortOrder: this.sortOrder,
            page: event.pageIndex,
            pageSize: event.pageSize,
            ...this.filtersForm.value
          })]);
        }});
  }


  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  async loadListData(): Promise<void> {
    this.formService.loadListFormRow2(this.paginator?.pageIndex,
      this.paginator?.pageSize,
      this.buildFilters(),
      {
        sortBy: this.sortBy,
        sortOrder: this.sortOrder
      });
  }
  expandElement(formRow: FormRow): void {
    this.expandedElement = this.expandedElement === formRow ? null : formRow;
    this.modify = false;
  }

  openModal(formRow: FormRow): void {
    const dialogRef = this.dialog.open(AddPartnerToFormDialogComponent, {
      width: '1200px',
      maxHeight: '400px',
      data: {uuid: formRow.uuid},
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result){
        this.loadListData();
      }
    });
  }
  openStatusModal(formRow: FormRow): void {
    const dialogRef = this.dialog.open(ChangeFormRowStatusDialogComponent, {
      width: '450px',
      maxHeight: '300px',
      data: {uuid: formRow.uuid},
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result){
        this.loadListData();
      }
    });
  }


  filter(): void {
    if (this.embeddedView) {
      if (this.paginator.pageIndex === 0) {
        this.loadListData();
      } else {
        this.paginator.firstPage();
      }
    } else {
      if (this.paginator.pageIndex === 0) {
        this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
          sortBy: this.sortBy,
          sortOrder: this.sortOrder,
          page: this.paginator.pageIndex,
          pageSize: this.paginator.pageSize,
          ...this.filtersForm.value
        })]);
      } else {
        this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
          sortBy: this.sortBy,
          sortOrder: this.sortOrder,
          page: 0,
          pageSize: this.paginator.pageSize,
          ...this.filtersForm.value,
        })]);
      }
    }
  }
  buildFilters(): any {
    const filters = {...this.initialFilters};
    if (null !== this.dynamicFormId) {
      filters.type = this.dynamicFormId;
    }

    return filters;
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    if (this.embeddedView) {
      this.loadListData();
    } else {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
        sortBy: this.sortBy,
        sortOrder: this.sortOrder,
        page: 0,
        pageSize: this.paginator.pageSize,
      }]);
    }
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      finder: 'string',
      in$status: 'int[]',
      gte$createdAt: 'date',
      lte$createdAt: 'date',
    }, filters);


  }

  public downloadReport(): void {
    this.formService.downloadRowReport(this.buildFilters())
      .subscribe((response: Uuid) => {
        this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });

  }
  calculateTimeDifference(targetDate: string): string {
    if (!targetDate){
      return '';
    }
    const now = new Date();
    const target = new Date(targetDate);
    target.setHours(target.getHours() - 1);
    const diff = target.getTime() - now.getTime();
    const diffInDays = Math.floor(diff / (1000 * 3600 * 24));
    const diffInHours = Math.floor((diff % (1000 * 3600 * 24)) / (1000 * 3600));
    const diffInMinutes = Math.floor((diff % (1000 * 3600)) / (1000 * 60));

    return `${diffInDays} dni, ${diffInHours} godzin, ${diffInMinutes} minut`;
  }

  getEmail(element: any): string {
    const emailEntry = element.data?.find((item: any) => item.key === 'email');
    return emailEntry?.value || '';
  }

  delete(formRow: FormRow): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć zgłoszenie?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.formService.deleteFormRow(formRow.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto zgłoszenie', '', {duration: 2000});
            this.loadListData();
          });
      }
    });
  }
}
